<template>
    <div id="app" :class="{ 'in-story' : inStory }">
        
        
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <Menu v-if="menuEnabled && assetsReady"/>
        </transition>
        <BackgroundContainer2D/>
        <BackgroundContainer3D v-if="assetsReady"/>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
                    @before-leave="checkMe" mode="out-in" @before-enter="checkMe">
            <router-view class="view"/>
        </transition>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <StoryTimeline v-if="viewStatus === 'story'"/>
        </transition>
        <keep-alive>
            <WaterPrint v-if="waterPrint && this.$route.name !== 'Load'"/>
        </keep-alive>
        <keep-alive>
        <StepByStepWizard v-if="stepByStep && this.$route.name !== 'Load'"/>
        </keep-alive>
    </div>
    
</template>

<script>
    import Navigation from "./components/Navigation";
    import EventBus from "./main";
    import StoryTimeline from "./components/StoryTimeline";
    import BackgroundContainer3D from "./components/BackgroundContainer3D";
    import Menu from "./components/Menu";
    import BackgroundContainer2D from "./components/BackgroundContainer2D";
    import WaterPrint from "./components/WaterPrint";
    import WaterPrintVisual from "./components/WaterPrintDrop";
    import StepByStepWizard from "./components/StepByStepWizard";
    export default {
        name: "YarininSuyu",
        data() {
            return {
                background: 'space',
                routerPath: '',
                menuEnabled: false,
                assetsReady: true,
                waterPrint: false,
                pageView: null,
                stepByStep: false,
                quantumMax: false
            }
        },
        computed: {
            viewStatus() {
                return this.$store.state.navigationStatus;
            },
            preCacheLoaded() {
                return this.$store.state.loaded;
            },
            inStory() {
                return this.$route.name.includes('Story');
            }
        },
        watch: {
            '$route' (to,from) {
                window.scroll(0,0);
            }
        },
        methods: {
            checkMe() {
                switch (this.$route.name) {
                    case 'Home':
                        EventBus.$emit('background-change', this.$route.name);
                        this.background = 'space';
                        break;
                    case ('Story1'):
                        EventBus.$emit('navigation-change');
                        EventBus.$emit('background-change', this.$route.name);
                        this.waterPrint = false;
                        break;
                    case ('Story2'):
                        EventBus.$emit('background-change', this.$route.name);
                        this.waterPrint = false;
                        break;
                    case ('Story3'):
                        EventBus.$emit('background-change', this.$route.name);
                        this.waterPrint = false;
                        break;
                    case ('Story4'):
                        EventBus.$emit('background-change', this.$route.name);
                        this.waterPrint = false;
                        break;
                    case ('Load'):
                        break;
                }
            }
        },
        beforeMount() {
            this.background = 'space';
            try {
                let cache = JSON.parse(localStorage.getItem('previous'));
                (parseInt(cache.d)) < new Date().getTime() ? this.$router.push({name: 'Load'}) : false;
            } catch (e) {
                return false;
            }
        },
        mounted() {
            (this.$route.name === 'WaterPrint' && (this.waterPrint = !this.waterPrint))
            // QueryString Redirect StepByStep Modal Show - Start
            if(window.location.href.indexOf('?') != -1){
                var queryStringsText = window.location.href.split('?')[1];
                var arrayQueryStrings = queryStringsText.split('&');
                arrayQueryStrings.forEach(item => {
                    var arrayText = item.split('=');
                    var key = arrayText[0];
                    var value = arrayText[1];
                    if(key == 'q' && (value == 'sudan-gecirmeden-temizle-social-media' || value == 'sudan-gecirmeden-temizle-posm' || value == 'sudan-gecirmeden-temizle-outdoor' || value == 'sudan-gecirmeden-temizle-mucize-doktor')) {
                        //$('#pop-up-survey').click();
                    }else if (key == 'q' && (value == 'tskb')) {
                        this.stepByStep = false;
                        this.waterPrint = true;
                    }
                })
            }
            // End
        },
        created() {
            if(window.location.pathname == '/finishin-surprizi-var'){
                this.quantumMax = true;
                $('body').addClass('back-image');
            }
            EventBus.$on('story-start', () => { this.inStory = true; });

            EventBus.$on('menu-status', (data) => { data === undefined ? this.menuEnabled = !this.menuEnabled : this.menuEnabled = data; });

            EventBus.$on('assets-ready', () => { this.assetsReady = true; });

            EventBus.$on('water-print-status', () => { this.waterPrint = !this.waterPrint; });

            EventBus.$on('last-story', () => { this.inStory = false; });
    
            /*if(window.location.pathname == '/') {
                this.stepByStep = true;
            }*/
            EventBus.$on('step-by-step-status', () => {
                this.stepByStep = !this.stepByStep; 
                /*if(!this.stepByStep){EventBus.$off('step-by-step-status')}else{EventBus.$on('step-by-step-status')}*/
                if(this.stepByStep == true) {
                    let searchParams = new URLSearchParams(window.location.search)
                    searchParams.set("site", "teste-basla");
                    let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                    history.pushState(null, '', newRelativePathQuery);
                }
            })
            /*let searchParams = new URLSearchParams(window.location.search)
            searchParams.set("site", "teste-basla");
            let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);*/
            this.$store.state.siteEnter = new Date().getTime();
        },
        components: {
            StepByStepWizard,
            WaterPrintVisual,
            WaterPrint, BackgroundContainer2D, Menu, StoryTimeline, BackgroundContainer3D, Navigation
        }
    };
</script>

<style lang="scss">
    @import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css");

    body {
        margin: 0;
        display: flex;
        font-family: "Quicksand", sans-serif, Tahoma;
        color: white;
        background-size: cover;
        background-position: center;
        background-image: url("../src/assets/backgrounds/space_background.jpg");
        background-repeat: no-repeat;
        background-attachment: fixed;
        @media only screen and (max-device-width: 768px) {
            font-size: 0.1vw;
        }
    }
    .back-image {
        background-image: url("../src/assets/backgrounds/quantum_background.jpg") !important;
        background-position: top left;
    }

    .back-image #background-container-3d {
        visibility: hidden;
    }
    #app {
        position: relative;
        width: 100%;
        height: auto;
        min-height: 800px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        min-width: 768px;

        @media only screen and (max-device-width: 768px) {
            height: auto;
            min-height: 100vh;
        }

        #page {
            position: relative;
            z-index: 10;
        }

        .view {
            z-index: 10;
        }

        &.in-story {
            height: 100vh;
        }
    }

    #preload_dune {
        background-image: url("../src/assets/backgrounds/dune_background.png");
        display: none;
    }

    canvas {
        outline: none;
    }
</style>
